import React, { useState } from 'react'
import {
  Dialog, DialogContent, DialogActions, DialogTitle, Typography, Button,
  useMediaQuery, useTheme
} from '@material-ui/core';
import { toFarsiDigits } from '../../assets/utils';
import ContractReportPanel from '../../components/contracts/ContractReportPanel';
import RequestReportDialog from '../../components/contracts/RequestReportDialog';

/**
 * پنلِ «صورت وضعیت» برای ناظر/مشاور:
 * همان «گزارش کلی» پیمانکار — انتخابِ نوع/سال مالی/سند و سپس «چاپ همه» یا «دانلود اکسل».
 */
export default function RequestsModal({ open, onClose, contract }) {
  const [reportFor, setReportFor] = useState(null);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const handleClose = () => {
    if (onClose) onClose();
  };

  return (
    <Dialog
      open={!!open}
      onClose={handleClose}
      fullWidth
      maxWidth="xl"
      fullScreen={isMobile}
      style={{ direction: 'rtl' }}
    >
      <DialogTitle>
        {contract
          ? `صورت‌وضعیت‌های قرارداد ${toFarsiDigits(contract.number ?? contract.id)}`
          : 'صورت‌وضعیت‌ها'}
      </DialogTitle>

      <DialogContent dividers>
        {contract ? (
          <ContractReportPanel contract={contract} onOpenRequest={setReportFor} />
        ) : (
          <Typography>قراردادی انتخاب نشده است.</Typography>
        )}
      </DialogContent>

      <DialogActions>
        <Button onClick={handleClose} color="primary" variant="contained">
          بستن
        </Button>
      </DialogActions>

      <RequestReportDialog
        open={!!reportFor}
        contractId={contract?.id}
        requestId={reportFor?.id}
        onClose={() => setReportFor(null)}
      />
    </Dialog>
  );
}
